import React from 'react';
import { cn } from '@/lib/cn';

export interface TextCellProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Main text content */
  children: React.ReactNode;
  /** Optional trailing element (shown on the right) - can be text or ReactNode */
  trailing?: React.ReactNode;
  /** Optional leading icon element */
  leadingIcon?: React.ReactNode;
}

export function TextCell({ children, trailing, leadingIcon, className, ...props }: TextCellProps) {
  const isTrailingText = typeof trailing === 'string';

  return (
    <div
      className={cn('flex items-center gap-4 px-2 py-3 rounded-lg bg-primary', className)}
      {...props}
    >
      {leadingIcon && (
        <div className="w-6 h-6 shrink-0 flex items-center justify-center">{leadingIcon}</div>
      )}
      {trailing ? (
        <>
          <p className="basis-0 grow min-w-0 text-body-2 text-primary truncate">{children}</p>
          {isTrailingText ? (
            <p className="font-semibold text-body-2 text-primary shrink-0 whitespace-nowrap">
              {trailing}
            </p>
          ) : (
            <div className="shrink-0">{trailing}</div>
          )}
        </>
      ) : (
        <p className="basis-0 grow min-w-0 text-body-2-high text-primary truncate">{children}</p>
      )}
    </div>
  );
}

export default TextCell;
